import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { getInvestmentsData } from 'store/features/investments/actions';
import Payements from './Payements';
import { AppDispatch, RootState } from 'store/types';

const mapStateToProps = (state: RootState) => ({
  investment: state.investments.status,
});

const mapDispatchToProps = (dispatch: AppDispatch) => ({
  actions: bindActionCreators({ getInvestmentsData }, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(Payements);
